import { FC } from "react";
import CenterWrapper from "Components/CenterWrapper";
import { Title, Wrapper } from "./Weather.styled";
import DateTime from "Components/DateTime";
import Day from "./Day";

type Props = {
  weather: any;
};

const Weather: FC<Props> = ({ weather }) => {
  if (!weather) {
    return null;
  }

  return (
    <CenterWrapper>
      <Title>Weather</Title>
      <Wrapper>
        {weather.forecast.forecastday.map((day: any, i: number) => {
          return <Day key={i} day={day} />;
        })}
      </Wrapper>
    </CenterWrapper>
  );
};

export default Weather;
